export default function convertNumbersToWords(text: string): string {
  const words = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

  return text
    .split('')
    .map((char) => {
      const number = parseInt(char, 10);
      return Number.isNaN(number) ? char : words[number];
    })
    .join('');
}
